interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1).filter((page) => {
    if (total <= 7) return true;
    if (page === 1 || page === total) return true;
    return Math.abs(page - current) <= 1;
  });

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page, index) => {
        const previous = pages[index - 1];
        const gap = previous && page - previous > 1;
        return (
          <span key={page} className="flex items-center gap-2">
            {gap && <span className="text-foreground-400">…</span>}
            <button
              type="button"
              onClick={() => onChange(page)}
              className={`h-9 w-9 cursor-pointer rounded-md text-sm font-medium transition-colors ${
                page === current
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
              }`}
            >
              {page}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}